export enum LocalStorageKeys {
  jwtToken = 'jwtToken',
  user = 'user',
}

export enum ApiStatus {
  idle = 'idle',
  loading = 'loading',
  failed = 'failed',
}

export enum DateFormats {
  defaultDate = 'MM/dd/yyyy',
  detailedDateTime = 'dd/MM/yyyy HH:mm',
  detailedDayDate = 'MMM dd, yyyy hh:mm a',
  longDate = 'MMM dd, yyyy',
  shortDate = 'MMM dd',
  onlyWeekday = 'eeee',
  onlyDay = 'dd',
  onlyMonth = 'MMM',
  monthAndYear = 'MM/yyyy',
  transactionDate = 'yyyy-MM-dd',
  yearMonth = 'yyyy-MM',
  year = 'yyyy',
}

export enum Roles {
  admin = 'admin',
  user = 'user',
}

export enum ConfirmationTypes {
  Error = 'error',
  Warning = 'warning',
  Success = 'success',
  Scheduled = 'scheduled',
  Custom = 'custom',
}

export enum TableHeaderColors {
  general = 'general',
  warning = 'warning',
}

export enum SortOrder {
  asc = 'asc',
  desc = 'desc',
}

export enum NewsType {
  default = 'default',
}
